<ng-container>
	<app-ea-spinner *ngIf="!users || !exploitations"></app-ea-spinner>
	<!--TODO <my-error-component *ngIf="data.error" [error]="data.error"></my-error-component> -->
	<div *ngIf="users && exploitations">
		<div class="flex align-items-center justify-content-between pt-3 pb-5 px-4" id="header">
			<div class="pl-3 overflow-hidden">
				<span class="block text-4xl font-bold">{{ "chart.dashboard" | translate }}</span>
			</div>
		</div>
		<div class="grid p-fluid">
			<div class="col-12">
				<div class="card">
					<div class="widget-header flex flex-wrap align-items-center justify-content-between pb-5">
						<div class="header-left-section flex align-items-center justify-content-start mb-3 md:mb-0">
							<h5 class="centerText">{{ "chart.cheptelstate" | translate }}</h5>
						</div>
					</div>
					<div class="grid p-fluid">
						<div class="col-6 md:col-12 xl:col-6">
							<div class="flex justify-content-center">
								<p-chart
									type="pie"
									[data]="statusEnablePieData"
									[options]="statusEnablePieOptions"
									[style]="{ width: '70%' }"></p-chart>
							</div>
						</div>
						<div class="col-6 md:col-12 xl:col-6">
							<div class="flex justify-content-center">
								<p-chart
									type="doughnut"
									[data]="statusSynchroPieData"
									[options]="statusSynchroPieOptions"
									[style]="{ width: '70%' }"></p-chart>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12">
				<div class="card">
					<div class="widget-header flex flex-wrap align-items-center justify-content-between pb-5">
						<div class="header-left-section flex align-items-center justify-content-start mb-3 md:mb-0">
							<h5 class="centerText">{{ "chart.chepteldesc" | translate }}</h5>
						</div>
						<div class="header-right-section flex align-items-center justify-content-end mb-3 md:mb-0">
							<p-multiSelect
								[options]="filtrageOptions"
								[(ngModel)]="selectedMultiFiltrageOptionsFirstCard"
								placeholder="Filtrage"
								optionLabel="name"
								[showHeader]="false"
								(onChange)="
									updateFilterFirstCard(); abonnementOverview.refresh(); departementOverview.refresh()
								">
								<ng-template let-selectedMultiFiltrageOptionsFirstCard pTemplate="selectedItems">
									<span>{{ selectedMultiFiltrageStringFirstCard }}</span>
									<div
										*ngIf="
											!selectedMultiFiltrageStringFirstCard || selectedMultiFiltrageString === ''
										">
										{{ "chart.filtrage" | translate }}
									</div>
								</ng-template>
								<ng-template let-filtrageOptions pTemplate="item">
									<div>
										<div>{{ filtrageOptions.label }}</div>
									</div>
								</ng-template>
							</p-multiSelect>
						</div>
					</div>
					<div class="grid p-fluid">
						<div class="col-6 md:col-12 xl:col-6">
							<div class="flex justify-content-center">
								<p-chart
									#abonnementOverview
									type="pie"
									[data]="abonnementPieData"
									[options]="abonnementPieOptions"
									[style]="{ width: '70%' }"></p-chart>
							</div>
						</div>
						<div class="col-6 md:col-12 xl:col-6">
							<div class="flex justify-content-center">
								<p-chart
									#departementOverview
									type="doughnut"
									[data]="departementPieData"
									[options]="departementPieOptions"
									[style]="{ width: '70%' }"></p-chart>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12">
				<div class="card">
					<div class="widget-header flex flex-wrap align-items-center justify-content-between pb-5">
						<div class="header-left-section flex align-items-center justify-content-start mb-3 md:mb-0">
							<h5 class="centerText">{{ "chart.statuscount" | translate }}</h5>
						</div>
						<div class="header-right-section flex align-items-center justify-content-end mb-3 md:mb-0">
							<p-multiSelect
								[options]="filtrageOptions"
								[(ngModel)]="selectedMultiFiltrageOptionsSecondCard"
								placeholder="Filtrage"
								optionLabel="name"
								[showHeader]="false"
								(onChange)="
									updateFilterSecondCard();
									hasDatahub.refresh();
									hasTbt.refresh();
									hasLots.refresh();
									hasMedria.refresh()
								">
								<ng-template let-selectedMultiFiltrageOptionsSecondCard pTemplate="selectedItems">
									<span>{{ selectedMultiFiltrageStringSecondCard }}</span>
									<div
										*ngIf="
											!selectedMultiFiltrageStringSecondCard || selectedMultiFiltrageString === ''
										">
										{{ "chart.filtrage" | translate }}
									</div>
								</ng-template>
								<ng-template let-filtrageOptions pTemplate="item">
									<div>
										<div>{{ filtrageOptions.label }}</div>
									</div>
								</ng-template>
							</p-multiSelect>
						</div>
					</div>
					<div class="grid p-fluid">
						<div class="col-3 md:col-6 xl:col-3">
							<div class="flex justify-content-center">
								<p-chart
									#hasDatahub
									type="pie"
									[data]="statusDatahubPieData"
									[options]="statusDatahubPieOptions"
									[style]="{ width: '70%' }"></p-chart>
							</div>
						</div>
						<div class="col-3 md:col-6 xl:col-3">
							<div class="flex justify-content-center">
								<p-chart
									#hasTbt
									type="pie"
									[data]="statusTbtPieData"
									[options]="statusTbtPieOptions"
									[style]="{ width: '70%' }"></p-chart>
							</div>
						</div>
						<div class="col-3 md:col-6 xl:col-3">
							<div class="flex justify-content-center">
								<p-chart
									#hasLots
									type="pie"
									[data]="statusLotsPieData"
									[options]="statusLotsPieOptions"
									[style]="{ width: '70%' }"></p-chart>
							</div>
						</div>
						<div class="col-3 md:col-6 xl:col-3">
							<div class="flex justify-content-center">
								<p-chart
									#hasMedria
									type="pie"
									[data]="statusMedriaPieData"
									[options]="statusMedriaPieOptions"
									[style]="{ width: '70%' }"></p-chart>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-6 md:col-12 xl:col-6">
				<div class="card">
					<h5 class="centerText">{{ "chart.cheptelevolution" | translate }}</h5>
					<div class="widget-overview-chart h-full">
						<div class="card-header">
							<span class="font-bold"></span>
							<p-dropdown
								[options]="cheptelCreatedOverviewPeriod"
								[(ngModel)]="cheptelCreatedSelectedOverviewPeriod"
								optionLabel="period"
								(onChange)="
									changeExploitationOverviewPeriod($event);
									cheptelOverview.refresh();
									cheptelOverview2.refresh()
								"></p-dropdown>
						</div>

						<div class="graph mb-3">
							<p-chart
								#cheptelOverview
								type="bar"
								[data]="cheptelCreatedLinearData"
								[options]="cheptelCreatedLinearOptions"
								[style]="{ width: '70%' }"></p-chart>
							<p-chart
								#cheptelOverview2
								type="line"
								[data]="cheptelTotalLinearData"
								[options]="cheptelTotalLinearOptions"
								[style]="{ width: '70%' }"></p-chart>
						</div>
					</div>
				</div>
			</div>
			<div class="col-6 md:col-12 xl:col-6">
				<div class="card">
					<h5 class="centerText">{{ "chart.userevolution" | translate }}</h5>
					<div class="widget-overview-chart h-full">
						<div class="card-header">
							<span class="font-bold"></span>
							<p-dropdown
								[options]="userCreatedOverviewPeriod"
								[(ngModel)]="userCreatedSelectedOverviewPeriod"
								optionLabel="period"
								(onChange)="
									changeUserOverviewPeriod($event); userOverview.refresh(); userOverview2.refresh()
								"></p-dropdown>
						</div>

						<div class="graph mb-3">
							<p-chart
								#userOverview
								type="bar"
								[data]="userCreatedLinearData"
								[options]="userCreatedLinearOptions"
								[style]="{ width: '70%' }"></p-chart>
							<p-chart
								#userOverview2
								type="line"
								[data]="userTotalLinearData"
								[options]="userTotalLinearOptions"
								[style]="{ width: '70%' }"></p-chart>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
